import {
  DOMAIN,
  CONFIRM_EMAIL_RESOURCE,
  RESEND_LINK_RESOURCE
} from './constants'
import {
  isCommInProgress,
  isCommCompleted,
  isCommSuccess,
  isCommFailure
} from '../../modules/communication'
import { hget } from '../../modules/hash'

export const isConfirmInProgress = state =>
  !isCommCompleted(CONFIRM_EMAIL_RESOURCE, state) &&
  isCommInProgress(CONFIRM_EMAIL_RESOURCE, state)

export const isConfirmSuccess = state =>
  isCommSuccess(CONFIRM_EMAIL_RESOURCE, state)

export const isConfirmFailed = state =>
  isCommFailure(CONFIRM_EMAIL_RESOURCE, state)

export const isResendInProgress = state =>
  !isCommCompleted(RESEND_LINK_RESOURCE, state) &&
  isCommInProgress(RESEND_LINK_RESOURCE, state)

export const isResendSuccess = state =>
  isCommSuccess(RESEND_LINK_RESOURCE, state)
export const isResendFailed = state =>
  isCommFailure(RESEND_LINK_RESOURCE, state)

export const isLinkSent = state => Boolean(hget(DOMAIN, 'linkSent', state))



// WEBPACK FOOTER //
// ./src/services/email-verification/selectors.js